import { freeUserUpgradeStep } from '../utils';

export const donationsListFoodMoverTour = {
  tourKey: 'donations_list_food_mover',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['foodMover'],
  },
  steps: [
    {
      title: 'tours.donations-list.welcome-npo.title',
      content: 'tours.donations-list-food-mover.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="donation-date-range"]',
      title: 'tours.donations-list.date-range.title',
      content: 'tours.donations-list.date-range.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="donations-table"]',
      title: 'tours.donations-list.table-business.title',
      content: 'tours.donations-list.table-npo.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
